export default __webpack_public_path__ + "static/media/lettie.1633254e.webp";